import React, { Component } from "react";
import styles from "./controlPoints.module.scss";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import AddTaskIcon from "@mui/icons-material/AddTask";
import { withLogisticGroups } from "../../../shared/containers/containerLogisticGroups";
import Input from "../../../shared/items/contols/input";
import Scrollbars from "react-custom-scrollbars-2";
import { withLogisticControlPoints } from "../../../shared/containers/containerLogisticControlPoints";
import ModalConfirmWindow from "../../Contents/ModalComponents/ModalConfirmWindow";
import DeleteConfirm from "../../Contents/ModalComponents/DeleteConfirm";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { withAuth } from "../../../shared/containers/containerAuth";

class GroupsControlPoints extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isViewCreate: false,
      createTitle: null,
      isDeleteModalOpen: false,
      deleteLogisticGroup: null,
      isViewSelected: false,
    };
  }

  handleChangeStore(name, value) {
    this.setState({ createTitle: value });
  }

  handleCreateGroup() {
    const { onCreateLogisiticGroups } = this.props;
    const { createTitle } = this.state;
    onCreateLogisiticGroups({ title: createTitle });
    this.setState({ isViewCreate: false });
  }

  onDelete(group) {
    const { onDeleteLogisiticGroups } = this.props;
    onDeleteLogisiticGroups(group);
  }

  onSelectGroup(group) {
    const { onSelectLogisticGroup } = this.props;
    onSelectLogisticGroup(group);
  }

  onClickCheker(isAdd, controlPoint) {
    const { onCreateControlPointLogisiticGroups, onDeletelControlPointLogisiticGroups, logisticSelectedGroup, data } = this.props;

    const addPermission = data.permissions.includes(47001);
    const deletePermission = data.permissions.includes(47002);

    if (isAdd) {
      if (addPermission) onCreateControlPointLogisiticGroups(controlPoint, logisticSelectedGroup);
    } else {
      if (deletePermission) onDeletelControlPointLogisiticGroups(controlPoint, logisticSelectedGroup);
    }
  }

  render() {
    const { isViewCreate, deleteLogisticGroup, isDeleteModalOpen, isViewSelected } = this.state;
    const { logisticControlPoints, logisticGroups, logisticSelectedGroup, data } = this.props;
    const height = window.innerHeight > 800 ? 650 : 450;

    const createGroupPermission = data.permissions.includes(46001);
    const deleteGroupPermission = data.permissions.includes(46002);

    return (
      <div className={styles.groupsControlPointContainer}>
        {createGroupPermission ? (
          isViewCreate ? (
            <div className={styles.createToolsContainer}>
              <TooltipWrapper title={"Отменить"} position="left">
                <HighlightOffIcon
                  className={styles.icon}
                  fontSize="large"
                  onClick={() => {
                    this.setState({ isViewCreate: false });
                  }}
                />
              </TooltipWrapper>
              <div className={styles.inputText}>
                <Input name="createTitle" type="text" placeholder="Новая группа" handleChangeStore={this.handleChangeStore.bind(this)} />
              </div>
              <TooltipWrapper title={"Создать"} position="left">
                <AddTaskIcon className={styles.iconAdd} fontSize="large" onClick={this.handleCreateGroup.bind(this)} />
              </TooltipWrapper>
            </div>
          ) : (
            <div style={{ display: "flex", width: "100%" }}>
              {logisticSelectedGroup !== null ? (
                <div
                  style={{ width: "400px", cursor: "pointer" }}
                  onClick={() => {
                    this.setState({ isViewSelected: !isViewSelected });
                  }}
                >
                  <input type="checkbox" checked={isViewSelected} />
                  <span>Показать только выбранные контрольные точки</span>
                </div>
              ) : null}

              <div className={styles.createToolsContainer}>
                <TooltipWrapper title={"Создать новую группу"} position="left">
                  <ControlPointIcon
                    className={styles.icon}
                    fontSize="large"
                    onClick={() => {
                      this.setState({ isViewCreate: true, createTitle: null });
                    }}
                  />
                </TooltipWrapper>
              </div>
            </div>
          )
        ) : (
          <div></div>
        )}

        <div className={styles.controlPointAndGroupsContainer}>
          <div className={styles.controlPointForGroup}>
            <div className={styles.controlPointItemTableForGroupHeader}>
              <div>Наименование</div>
              <div>Адрес</div>
              <div></div>
            </div>

            <div className={styles.controlPointsListTable}>
              <Scrollbars style={{ height: `${height}px` }} autoHide={true} ref="scrollbar">
                <div>
                  {logisticControlPoints
                    .filter((controlPoint) => {
                      const inGroup =
                        logisticSelectedGroup !== null &&
                        logisticSelectedGroup.controlPoints.some((x) => {
                          return x.id === controlPoint.id;
                        });

                      if (isViewSelected && !inGroup) return null;

                      return true;
                    })
                    .map((controlPoint, index) => {
                      const inGroup =
                        logisticSelectedGroup !== null &&
                        logisticSelectedGroup.controlPoints.some((x) => {
                          return x.id === controlPoint.id;
                        });

                      return (
                        <div
                          key={controlPoint.id}
                          className={styles.controlPointItemTableForGroup}
                          style={{ backgroundColor: index % 2 === 0 ? "#90c0db18" : "white" }}
                        >
                          <div>{controlPoint.title}</div>
                          <div>{controlPoint.address}</div>
                          <div
                            style={{ cursor: "pointer", paddingBottom: "0px" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              this.onClickCheker(!inGroup, controlPoint);
                            }}
                          >
                            {logisticSelectedGroup !== null ? (
                              <CheckCircleOutlineIcon fontSize="small" style={{ color: inGroup ? "#157fe1" : "#818698" }} />
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
              </Scrollbars>
            </div>
          </div>

          <div className={styles.groupsTableContainer}>
            <div className={styles.controlPointItemTableForGroupHeader}>
              <div>Наименование группы</div>
            </div>
            <div className={styles.controlPointsListTable}>
              <Scrollbars style={{ height: `${height}px` }} autoHide={false} ref="scrollbar">
                <div>
                  {logisticGroups.map((logisticGroup, index) => {
                    return (
                      <div
                        key={logisticGroup.id}
                        className={
                          logisticSelectedGroup !== null && logisticSelectedGroup.id === logisticGroup.id
                            ? styles.controlPointItemGroupSelect
                            : styles.controlPointItemGroup
                        }
                        style={{ backgroundColor: index % 2 === 0 ? "#90c0db18" : "white" }}
                        onClick={this.onSelectGroup.bind(this, logisticGroup)}
                      >
                        <div> {logisticGroup.title} </div>

                        {deleteGroupPermission ? (
                          <div
                            style={{ width: "50px" }}
                            onClick={(e) => {
                              e.stopPropagation();
                              this.setState({ isDeleteModalOpen: true, deleteLogisticGroup: logisticGroup });
                            }}
                          >
                            <TooltipWrapper title={`Удалить контрольную точку ${logisticGroup.title}`} position="top">
                              <DeleteIcon fontSize="small" />
                            </TooltipWrapper>
                          </div>
                        ) : (
                          <div></div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </Scrollbars>
            </div>
          </div>
        </div>

        {deleteLogisticGroup !== null ? (
          <ModalConfirmWindow isOpen={isDeleteModalOpen}>
            <DeleteConfirm
              onConfirmHandle={() => {
                this.onDelete(deleteLogisticGroup);
                this.setState({ isDeleteModalOpen: false, deleteLogisticGroup: null });
              }}
              onNotConfirmHandle={(e) => {
                this.setState({ isDeleteModalOpen: false, deleteLogisticGroup: null });
              }}
              text={`Удалить группу "${deleteLogisticGroup.title}"`}
            />
          </ModalConfirmWindow>
        ) : null}
      </div>
    );
  }
}

export default withAuth(withLogisticControlPoints(withLogisticGroups(React.memo(GroupsControlPoints))));
